export default __webpack_public_path__ + "static/media/yd-information.af05ae30.png";